import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PaymentPlaceholder({
  payment
}) {
  const formRef = React.useRef(null);
  React.useEffect(() => {
    if (payment && formRef.current !== null) {
      formRef.current.submit();
    }
  }, [payment]);
  if (!payment) {
    return null;
  }
  return /*#__PURE__*/_jsx("form", {
    ref: formRef,
    method: payment.method,
    action: payment.url || '/billing/payment-return',
    children: Object.keys(payment.params).map(key => /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: key,
      value: payment.params[key]
    }, key))
  });
}